import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export const ThemeToggle = ({ compact = false, className = "" }) => {
  const { isLight, toggle } = useTheme();
  const label = isLight ? "Switch to Night Mode" : "Switch to Day Mode";

  if (compact) {
    return (
      <button type="button" onClick={toggle} aria-label={label} title={label} data-testid="theme-toggle"
        data-theme={isLight ? "light" : "dark"}
        className="h-9 w-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-amber-400 hover:bg-white/10 transition-colors">
        {isLight ? <Moon className="w-4 h-4 text-cyan-400" /> : <Sun className="w-4 h-4" />}
      </button>
    );
  }

  return (
    <button type="button" onClick={toggle} role="switch" aria-checked={isLight} aria-label={label} data-testid="theme-toggle"
      data-theme={isLight ? "light" : "dark"}
      className={`group flex items-center gap-2.5 rounded-full border border-white/10 bg-white/5 p-1 pr-3 text-xs font-medium hover:border-white/30 transition-colors ${className}`}>
      <span className="relative h-7 w-[52px] rounded-full bg-[#121824] overflow-hidden shrink-0">
        <Moon className={`absolute left-1.5 top-1.5 w-4 h-4 text-cyan-400 transition-opacity duration-300 ${isLight ? "opacity-30" : "opacity-100"}`} />
        <Sun className={`absolute right-1.5 top-1.5 w-4 h-4 text-amber-400 transition-opacity duration-300 ${isLight ? "opacity-100" : "opacity-30"}`} />
        <span className={`absolute top-0.5 h-6 w-6 rounded-full bg-emerald-500 shadow transition-transform duration-300 ease-out ${isLight ? "translate-x-[26px]" : "translate-x-0.5"}`} />
      </span>
      <span className="text-slate-300" data-testid="theme-toggle-label">{isLight ? "Day Mode" : "Night Mode"}</span>
    </button>
  );
};
